import React, { useState, useEffect, useCallback } from "react";
import ProductList from "./ProductList";
import SearchAdminInsightsProducts from "../../graphql/queries/product/SearchAdminInsightsProducts";
import {
  Box,
  CSSReset,
  Heading,
  Progress,
  Input,
  Button,
  Flex,
  Select,
  HStack,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { debounce } from "lodash";
import { RouteComponentProps } from "react-router";

const ViewProducts: React.FC<RouteComponentProps> = (props) => {
  const [query, setQuery] = useState("");
  const [deferredQuery, setDeferredQuery] = useState("");
  const [reportTypeFilter, setReportTypeFilter] = useState<string | null>();

  const debouncedSetQuery = useCallback(debounce(setDeferredQuery, 250), []);

  useEffect(() => {
    debouncedSetQuery(query);
  }, [query]);

  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const q = searchParams.get("q");
    if (q) {
      setQuery(q.trim());
    }
  }, []);

  return (
    <Box>
      <CSSReset />
      <Flex alignItems="center" justifyContent="space-between">
        <Heading as="h3" size="lg" mb={4}>
          ETR Insights
        </Heading>
        <Button
          size="sm"
          variant="outline"
          colorScheme="blue"
          leftIcon={<AddIcon />}
          onClick={() => props.history.push("/products/new")}
        >
          Add Product
        </Button>
      </Flex>
      <HStack mb={3}>
        <Input
          flexGrow={2}
          placeholder="Search Products"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <Select
          maxWidth={300}
          onChange={(e) => setReportTypeFilter(e.target.value)}
        >
          <option value="">All Insights Products</option>
          <option value="VENN">Insights</option>
          <option value="VendorFocus">Vendor Focus</option>
          <option value="IndustryAnalysis">Industry Analysis</option>
          <option value="VEC">VEC</option>
          <option value="ObservatoryReport">Observatory Report</option>
        </Select>
      </HStack>
      <SearchAdminInsightsProducts
        query={deferredQuery}
        reportType={reportTypeFilter || null}
      >
        {({ data, loading, error, fetchMore }) => {
          if (loading) return <Progress size="xs" isIndeterminate />;
          return (
            <ProductList
              onWaypointReached={() => {
                fetchMore({
                  variables: {
                    offset: data?.products.length,
                  },
                  updateQuery: (prev, { fetchMoreResult }) => {
                    if (fetchMoreResult?.products.length) {
                      return {
                        products: [
                          ...prev.products,
                          ...fetchMoreResult.products,
                        ],
                      };
                    }
                    return prev;
                  },
                });
              }}
              loading={loading}
              error={error}
              products={data?.products}
            />
          );
        }}
      </SearchAdminInsightsProducts>
    </Box>
  );
};

export default ViewProducts;
